import React from "react";
import { Grid } from "@material-ui/core";
import {
  InputTextMaster,
  InputOptionMaster,
  InputFileCustom,
  InputRadioButton,
  InputReactDatepicker,
} from "App/Component/ui";
import { useSelectOption } from "App/hooks";
import { TYPE_INSTANCE1, TYPE_INSTANCE2 } from "App/constants";
import { isEmpty } from "lodash";
import { valueStatusPernikahan } from ".";
import { messageError } from "utils/all";

export default function FormDataPasien({
  formData,
  handleChange,
  setFormData,
  photo,
  setPhoto,
}) {
  const bloodType = useSelectOption(
    false,
    "/atribut/atr_ms_bloodtype/list_prm",
    TYPE_INSTANCE2
  );

  const listEthnic = useSelectOption(
    false,
    "/atribut/atr_ms_ethnic/list_prm",
    TYPE_INSTANCE2
  );

  const listReligion = useSelectOption(
    false,
    "/agama/list-prm",
    TYPE_INSTANCE1
  );

  const listEducation = useSelectOption(
    false,
    "/atribut/atr_ms_education/list_prm",
    TYPE_INSTANCE2
  );

  const listJobs = useSelectOption(
    false,
    "/atribut/atr_ms_jobs/list_prm",
    TYPE_INSTANCE2
  );

  return (
    <>
      <p className='fw-600 mt-2'>DATA PASIEN</p>
      <div className='mt-1'>
        <Grid container spacing={1}>
          <Grid item sm={3}>
            <InputTextMaster
              name='place_ob'
              label='TEMPAT LAHIR'
              id='place_ob'
              placeholder='Tempat Lahir'
              onChange={handleChange("place_ob")}
              value={formData.place_ob}
              error={true}
              message={messageError.required}
            />
          </Grid>
          <Grid item sm={3}>
          <InputReactDatepicker
              selected={formData.date_ob_form}
              label="TANGGAL LAHIR"
              handleChangeToday={(e) =>
                setFormData({
                  ...formData,
                  date_ob_form: e,
                })
              }
              onChange={(e) =>
                setFormData({
                  ...formData,
                  date_ob_form: e,
                })
              }
              error={true}
              message={messageError.required}
            />
          </Grid>

          <Grid item xs={3}>
            <InputOptionMaster
              name='blood_type'
              label='GOLONGAN DARAH'
              id='blood_type'
              value={formData.blood_type}
              onChange={handleChange("blood_type")}
              error={true}
              message={messageError.required}
              data={bloodType}
            />
          </Grid>

          <Grid item sm={3}>
            <div
              style={{
                display: "flex",
                gap: "20px",
                marginTop: "1.7rem",
              }}>
              <InputRadioButton
                label={"Laki-Laki"}
                size={"18"}
                id='gender_pria'
                name='gender'
                value='1'
                initialValue={formData.gender?.toString()}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    gender: "1",
                  })
                }
              />
              <InputRadioButton
                label={"Perempuan"}
                size={"18"}
                id='gender_wanita'
                name='gender'
                value='2'
                initialValue={formData.gender?.toString()}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    gender: "2",
                  })
                }
              />
            </div>
          </Grid>

          <Grid item sm={3}>
            <InputTextMaster
              name='namaayah'
              label='NAMA AYAH'
              id='namaayah'
              placeholder='Nama Ayah'
              onChange={handleChange("namaayah")}
              error={true}
              message={messageError.required}
              value={formData.namaayah}
            />
          </Grid>
          <Grid item sm={3}>
            <InputOptionMaster
              name='statuspernikahan'
              label='STATUS PERNIKAHAN'
              id='statuspernikahan'
              needParse={false}
              onChange={handleChange("statuspernikahan")}
              value={formData.statuspernikahan}
              data={valueStatusPernikahan}
              error={true}
              message={messageError.required}
            />
          </Grid>

          <Grid item sm={3}>
            <InputOptionMaster
              name='ethnic'
              label='SUKU BANGSA'
              id='ethnic'
              onChange={handleChange("ethnic")}
              value={formData.ethnic}
              data={listEthnic}
              error={true}
              message={messageError.required}
            />
          </Grid>

          <Grid item sm={3}>
            <InputTextMaster
              name='no_hp'
              label='NO.HP'
              id='no_hp'
              value={formData.mobile_phone_number}
              placeholder='No. Hp Pasien'
              onChange={handleChange("mobile_phone_number")}
              error={true}
              message={messageError.required}
            />
          </Grid>
          <Grid item sm={3}>
            <InputTextMaster
              name='no_telp'
              label='NO. TELEPON'
              id='no_telp'
              value={formData.phone_number}
              placeholder='No. Telp Pasien'
              onChange={handleChange("phone_number")}
              error={true}
              message={messageError.required}
            />
          </Grid>

          <Grid item sm={3}>
            <InputOptionMaster
              name='agama'
              label='AGAMA'
              id='agama'
              value={formData.religion}
              onChange={handleChange("religion")}
              needParse={false}
              data={listReligion}
              error={true}
              message={messageError.required}
            />
          </Grid>

          <Grid item sm={3}>
            <InputOptionMaster
              name='pendidikan'
              label='PENDIDIKAN'
              id='pendidikan'
              onChange={handleChange("education")}
              value={formData.education}
              needParse={false}
              data={listEducation}
            />
          </Grid>
          <Grid item sm={3}>
            <InputOptionMaster
              name='pekerjaan'
              label='PEKERJAAN'
              id='pekerjaan'
              needParse={false}
              onChange={handleChange("occupation")}
              value={formData.occupation}
              data={listJobs}
              error={true}
              message={messageError.required}
            />
          </Grid>

          <Grid item sm={3}>
            <InputTextMaster
              name='nip'
              label='NIP'
              id='nip'
              placeholder='NIP'
              value={formData.nip}
              onChange={handleChange("nip")}
            />
          </Grid>
          <Grid item sm={3}>
            <InputTextMaster
              name='npwp'
              label='NPWP'
              id='npwp'
              placeholder='NPWP'
              value={formData.npwp}
              onChange={handleChange("npwp")}
            />
          </Grid>

          <Grid item sm={4}>
            <label
              htmlFor='photo'
              style={{
                fontWeight: 400,
                color: "#BDBDBD",
                fontSize: "11px",
              }}>
              Photo
            </label>
            <InputFileCustom
              label={"Upload File"}
              name={"photo"}
              id={"photo"}
              initialNameFile={photo}
              setFile={setPhoto}
            />

            {!isEmpty(photo) && (
              <img
                src={photo}
                alt='Foto Dokter'
                style={{
                  height: "200px",
                }}
              />
            )}
          </Grid>
        </Grid>
      </div>
    </>
  );
}
